import { render } from "./TBaseButton.vue?vue&type=template&id=cb7fa47c&scoped=true"
import script from "./TBaseButton.vue?vue&type=script&lang=js"
export * from "./TBaseButton.vue?vue&type=script&lang=js"

import "./TBaseButton.vue?vue&type=style&index=0&id=cb7fa47c&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7fa47c"]])

export default __exports__